import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <p>Arce Serviços Modulados e Planejados Ltda - CNPJ: 41.278.236/0001-71</p>
        <p>Endereço: Avenida Desembargador João Machado número 1600, Alvorada, Manaus-AM, CEP 69042-360, Brasil - Horário de Funcionamento: Segunda à Sexta, de 09:00 às 16:00</p>
        <p>Telefone: (92) 98118-2887 - Clique na opção WhatsApp para ser atendido | &copy; 2025 | Todos os direitos reservados </p>
        <p> - </p>
        <p>Os projetos de móveis exibidos neste site são exemplos de projetos e não estão disponíveis para comercialização ou venda,
          integral ou separadamente. Não atuamos com produção e comercialização em série. Desenvolvemos projetos personalizados</p>
        <p>sob medida, com design de alto padrão, buscando excelência técnica e customização completa. Cada projeto é único e desenvolvido sob medida
          para as necessidades e conforme especificidades de nossos clientes.</p>
      </div>
    </footer>
  );
};

export default Footer;